/**
 * File misc.js.
 */
(function () {
    document.querySelectorAll('ol[start], ul[start]').forEach((list) => {
        list.style.setProperty('--start', list.getAttribute('start'));
    });

    document.querySelectorAll('.wp-block-table').forEach((table) => {
        const thList = [];
        table.querySelectorAll('tr th').forEach((th) => {
            if (th.textContent) {
                thList.push(th.textContent);
            }
        });

        if (thList) {
            let i = 0;
            table.querySelectorAll('tbody tr td').forEach((td) => {
                td.style.setProperty("--th-title", `"${thList[i++]}"`);
            });
        }
    });
}());